(function() {
  'use strict';

  function isProductDetailPage() {
    return /^\/products\/[^\/?#]+/i.test(window.location.pathname);
  }
  function isMonogramProduct() {
    return /monogram-weasley-jumper/i.test(window.location.pathname);
  }

  function injectFitNotes() {
    if (!isProductDetailPage()) return;
    if (isMonogramProduct()) return;

    var forms = document.querySelectorAll('main product-form-component form, main form[action*="/cart/add"]');
    if (forms.length === 0) {
      forms = Array.prototype.filter.call(
        document.querySelectorAll('product-form-component form, form[action*="/cart/add"]'),
        function(f) {
          return !f.closest('quick-add-modal, dialog, [role="dialog"], .quick-add, .modal');
        }
      );
    }
    forms.forEach(function(form) {
      if (form.dataset.dmkFitNotesAdded === '1') return;

      var submitBtn = form.querySelector('button[type="submit"]');
      if (!submitBtn) return;

      form.dataset.dmkFitNotesAdded = '1';

      var uid = 'dmk-fit-notes-' + Math.random().toString(36).slice(2, 8);

      var block = document.createElement('div');
      block.className = 'dmk-fit-block';
      block.innerHTML =
        '<label for="' + uid + '" class="dmk-fit-label">' +
          '<span class="dmk-fit-title">Fit notes <em>(optional)</em></span>' +
        '</label>' +
        '<textarea id="' + uid + '" name="properties[Fit Notes]" class="dmk-fit-textarea" rows="2" maxlength="500" ' +
          'placeholder="e.g., Height 175cm, Weight 68kg, Chest 96cm…"></textarea>';

      var btnContainer = submitBtn.closest('.product-form-buttons, product-form-buttons, .product-form__buttons') || submitBtn.parentElement;
      if (btnContainer && btnContainer.parentElement) {
        btnContainer.parentElement.insertBefore(block, btnContainer);
      }
    });
  }

  function init() {
    injectFitNotes();
    var observer = new MutationObserver(function() { injectFitNotes(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
